import { formatDate } from '@root/helpers';
import type { CellContext, ColumnHelper } from '@tanstack/react-table';

export const effectiveFromAccessor = <T extends { inception_date?: string | null }>(columnHelper: ColumnHelper<T>) =>
  // Deactivate/reactivate store null, which `sortUndefined` ignores and `datetime` ranks equal to every date.
  columnHelper.accessor((row) => row.inception_date || undefined, {
    id: 'inception_date',
    header: 'Effective from',
    enableColumnFilter: false,
    size: 128,
    minSize: 128,
    maxSize: 128,
    cell: (cellContext: CellContext<T, string>) =>
      formatDate(cellContext.row.original.inception_date ?? '', 'DD MMM YYYY'),
    sortingFn: 'datetime',
    sortUndefined: -1,
    meta: {
      headingCellClassName: 'w-32',
    },
  });
